<template>
    <Breadcrumbs :here="`${branchName}支店の差分概要`"
                 :ancestries="ancestries"/>
    <div class="row">
        <div class="col h2"
             :style="{ fontSize: FontSizes.large2}">{{ branchName }}支店の配布記録データ差分概要</div>
    </div>
    <div class="row my-2">
        <div class="container col-sm col-md-8">
            <div class="row justify-content-end mt-2">
                <div class="col-4">更新日時：{{ updatedDTString() }}</div>
            </div>
            <div class="row table-header-row">
                <div class="col-2">ID</div>
                <div class="col-5">スタッフ</div>
                <div class="col-5">差分概要</div>
            </div>
            <div v-for="staffDiff in branchDiffSummary.entities"
                 :key="staffDiff.vForKey"
                 class="row summary-row">
                <div class="col-2 summary-col">
                    <span class="wrap-text">{{ staffDiff.staffId }}</span>
                </div>
                <div class="col-5 summary-col">
                    <span class="wrap-text">
                        <a v-if="staffDiff.hasDiff"
                           @click.prevent="onClickStaffDiffSummary(staffDiff.staffId, staffDiff.name)"
                           href="#">{{ staffDiff.name }}</a>
                        <template v-else>{{ staffDiff.name }}</template>
                    </span>
                </div>
                <div class="col-5 summary-col align-self-center">
                    <p class="diff-text"
                       :class="{'added': staffDiff.added > 0}">追加：{{ staffDiff.added }}</p>
                    <p class="diff-text"
                       :class="{'changed': staffDiff.changed > 0}">変更：{{ staffDiff.changed }}</p>
                    <p class="diff-text"
                       :class="{'deleted': staffDiff.deleted > 0}">削除：{{ staffDiff.deleted }}</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {backendApi} from "@/utils/backend-api";
import {datetimeFormat, subPaths} from "@/utils/consts";
import {useRoute, useRouter} from "vue-router";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {FontSizes} from "@/utils/font-sizes";
import Breadcrumbs, {ancestryType} from "@/components/Breadcrumbs.vue";
import {PostingRecordAllDiffSummary} from "@/data-models/posting-record-all-diff-summary";
import {format} from "date-fns";
import {Staff} from "@/data-models/staff";
import {PostingRecordBranchDiffSummary, StaffDiffEntity} from "@/data-models/posting-record-branch-diff-summary";

export default defineComponent({
    name: "PostingRecordsAllDiff",
    components: {Breadcrumbs},
    setup() {

        const branchName = ref<string>(""),
            ancestries = ref<ancestryType[]>([] as ancestryType[]),
            branchDiffSummary = ref<PostingRecordBranchDiffSummary>(new PostingRecordBranchDiffSummary())

        // const recordDiffSummary = ref<PostingRecordAllDiffSummary>(new PostingRecordAllDiffSummary())

        const router = useRouter()

        onMounted(async () => {

            const branchNameQuery = useRoute().query.name as string
            if (branchNameQuery) {
                branchName.value = branchNameQuery

                ancestries.value = [
                    {
                        name: "ホーム",
                        pathObj: subPaths.HOME
                    },
                    {
                        name: branchName.value,
                        pathObj: {
                            path: subPaths.BRANCH_PAGE,
                            query: {
                                name: branchName.value
                            }
                        }
                    }
                ]

                const diffResp = await backendApi.inquirePostingRecordsBranchDiff(branchName.value)
                console.log(diffResp.value)

                const staffListResp = await backendApi.inquireStaffList(branchName.value, 0)
                console.log(staffListResp.value)

                if (diffResp.isAuthorized && staffListResp.isAuthorized) {

                    const staffList = Staff.fromJsonArrToArr(staffListResp.value)

                    branchDiffSummary.value = PostingRecordBranchDiffSummary.fromJson(diffResp.value)
                    branchDiffSummary.value.entities.forEach(staffDiff => {
                        const staff = staffList.find(staff => staff.staffId === staffDiff.staffId)
                        if (staff) {
                            staffDiff.name = staff.displayName
                        }
                    })

                    console.log(branchDiffSummary.value)
                } else {
                    await router.push(subPaths.LOGIN)
                }


            }

            loadingOverlayStateStore.commit("fadeout")
        })

        const updatedDTString = (): string => {
            return format(branchDiffSummary.value.updatedAt as Date, datetimeFormat)
        }

        const onClickStaffDiffSummary = (staffId: number, staffName: string) => {

            loadingOverlayStateStore.commit("switchLoadingState", {
                show: true,
                message: `${staffName}さんの配布記録一覧に移動中…`,
                shouldTimeOut: false,
            })

            router.push({
                path: subPaths.MY_PAGE_POSTING_DATA_DIFF,
                query: {
                    staff_id: staffId
                }
            })
        }

        return {
            FontSizes,
            branchName,
            ancestries,
            branchDiffSummary,
            updatedDTString,
            onClickStaffDiffSummary,
        }
    }
})
</script>

<style scoped lang="scss">
.table-header-row {
    background-color: whitesmoke;
    height: 40px;
    border: 2px solid gray;
    line-height: 40px;
    font-weight: bold;

    div:not(:last-child) {
        border-right: 1px solid gray;
    }
}

.summary-row {
    border: 1px solid gray;
    border-top: none;

    .summary-col {

        border-right: 1px solid gray;

        &:last-child {
            border-right: none;
        }

        .diff-text {
            height: 30px;
            line-height: 30px;
            margin: 2px;
        }

        .added {
            background-color: #6affbb;
            color: #006839;
        }

        .changed {
            background-color: #FFE2BB;
            color: darkgoldenrod;
        }

        .deleted {
            background-color: #FFBBBB;
            color: red;
        }
    }


}

</style>